

import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "./Testing.css";
import { toast, ToastContainer } from "react-toastify";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50,100];
const secondaryTabs = ["All", "Active","Pending", "Closed", "Pre-Closed", "Reject"]; 

const Testing = () => {
      const [activeMainTab, setActiveMainTab] = useState("FD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [frequency, setFrequency] = useState("All");

  const [modalOpen, setModalOpen] = useState(false);
  const [adminRemark, setAdminRemark] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedreport,setselectedreport]=useState("");
  const [userid,setuserid]=useState("");

  const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
  

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);


  const fetchAccounts = async () => {
    try {
      setLoading(true);

  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

      const res = await axios.get("https://payyug.in/api/fdmis/all", {
        params: {
          superAdminId,
          accountType: activeMainTab,
        },
      });

    //   const accounts = Array.isArray(res?.data?.data)
    //   ? res.data.data
    //   : [];

    // // Remove pending accounts safely
    // const filtered = accounts.filter(
    //   (acc) =>
    //     acc?.status &&
    //     acc.status.trim().toLowerCase() !== "pending"
    // );

      if (res.data.success) {
        setAccounts(res.data.data||[]);
      }
    } catch (err) {
      console.error(err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchAccounts();
  }, [activeMainTab]);


    const filteredAccounts = useMemo(() => {
    let data = [...accounts];

    if (searchQuery.trim() !== "") {
        const query = searchQuery.toLowerCase();

        data = data.filter(
          (acc) =>
            acc.accountNo?.toLowerCase().includes(query) ||
            acc.customerName?.toLowerCase().includes(query)
        );
      }

    // 🔹 STATUS FILTER
    if (activeSecondary !== "All") {
      data = data.filter(
        (acc) =>
          acc.status?.toLowerCase() === activeSecondary.toLowerCase()
      );
    }

    // 🔹 FREQUENCY FILTER
    if (frequency !== "All") {
      data = data.filter(
        (acc) =>
          acc.installmentFrequency?.toLowerCase() ===
          frequency.toLowerCase()
      );
    }

    return data;
  }, [accounts, activeSecondary, frequency, searchQuery]);


   const submitStatusUpdate = async () => {
      if (!adminRemark.trim()) {
        return toast.error("Admin remark is required!");
      }
       const superAdminId = localStorage.getItem("superAdminId") || 14;
       try {
        await axios.post(
          `https://payyug.in/api/fdmis/${selectedStatus}`,
          {
            accountId:userid,
             ...(selectedStatus==="approve"
               ?{approvedBy:superAdminId}
               :{rejectedBy:superAdminId}),
            remarks:adminRemark,
          }
        );
        
        toast.success(`acc ${selectedStatus} successfully`);
        
        } catch (error) {
        toast.error(error?.response?.data?.error || "Failed to update account");
        setModalOpen(false);
      }
  };

    const openRemarkModal = (report,status) => {
    setuserid(report.id);
    setselectedreport(report);
    console.log(selectedreport.id);
    setSelectedStatus(status);
    setAdminRemark("");
    setModalOpen(true);
  };


// pagination(frontend)
  const totalPages = Math.max(
    1,
    Math.ceil(filteredAccounts.length / itemsPerPage)
  );

  const paginatedAccounts = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return filteredAccounts.slice(start, end);
  }, [filteredAccounts, currentPage, itemsPerPage]);

    // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeSecondary, searchQuery, frequency, itemsPerPage]);

  
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };


  return (
    <div className="rddd-account-report-container">
      {/* Filter Section */}
      <section className="rddd-report-filters-section">
         <h2 style={{ textAlign: "center", marginBottom: 10 }}>
          {activeMainTab} Account Report
        </h2>

        {/* Main Tabs */}
       <div className="rddd-report-filters-main-tabs">
         {["FD", "MIS"].map((tab) => (
          <button
            key={tab}
            className={`rddd-report-filters-main-tab ${
              activeMainTab === tab ? "active" : ""
            }`}
            onClick={() => setActiveMainTab(tab)}
          >
            {tab} Report
          </button>
        ))}
      </div>

       {/* Secondary Tabs */}
       <div className="rddd-report-filters-secondary-tabs">
         {secondaryTabs.map((tab) => (
          <button
            key={tab}
            className={`rddd-report-filters-secondary-btn ${
              activeSecondary === tab ? "active" : ""
            }`}
            onClick={() => setActiveSecondary(tab)}
          >
            {tab}
          </button>
        ))}
        </div>

        {/* <div className="dropdown-filter ">
           <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
          <option value="All">All</option>
          <option value="Daily">Daily</option>
          <option value="Weekly">Weekly</option>
          <option value="Monthly">Monthly</option>
        </select>
      </div> */}
      </section>

        <div className="rddd-report-search-section">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
          <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        </div>

        <div className="rddd-report-table-wrapper">
          <table className="rddd-report-table">
            <thead>
               <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Roi</th>
              <th>Deposit Amount</th>       
              <th>Tenure</th>               
              <th>Status</th>              
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
              {loading ? (
              <tr>
                <td colSpan="10" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : paginatedAccounts.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            ) : (
              paginatedAccounts.map((acc, index) => (
                <tr key={acc.id}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{acc.accountNumber|| "N/A"}</td>
                  <td>{acc.customerName || "N/A"}</td>
                  <td>{acc.accountType || "N/A"}</td>
                  <td>{`${acc.roi}%`|| "N/A"}</td>
                  <td>₹{acc.depositAmount || acc.minDeposit || 0}</td>
                  <td>{acc.tenureMonths || "N/A"}</td>
                  <td>{acc.status||"N/A"}</td>

                  <td>
                    <button
                          className="approve-btn"
                          // onClick={() => openRemarkModal(acc,"approve")}
                        >
                          Approve
                        </button>

                    <button
                          className="reject-btn"
                          // onClick={() => openRemarkModal(acc,"reject")}
                        >
                          Reject
                        </button>
                  </td>
                </tr>
              ))
            )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="rddd-report-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        )}


      {/* Modal */}
      {modalOpen && (
        <div className="remark-modal-overlay">
          <div className="remark-modal">
            <h3>
              {selectedStatus === "approve" ? "Approve report": "Reject report"}
            </h3>

            <textarea
              placeholder="Enter admin remark"
              value={adminRemark}
              onChange={(e) => setAdminRemark(e.target.value)}
            ></textarea>

            <div className="modal-buttons">
              <button className="modal-submit" onClick={submitStatusUpdate}>
                Submit
              </button>
              <button
                className="modal-cancel"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Testing;
